import { PRODUCT_TYPE_ID } from '../constants/ObjectTypeIds';
import { isMultiCurrencyPrice } from '../property/PropertyIdentifier';
import { isPricingModelTiered } from './Pricing';
export const EDITABLE_PRODUCT_BUNDLE_PROPERTIES = new Set(['name', 'hs_sku', 'description', 'hs_images', 'hs_status']);
export const isReadOnlyProductProperty = (objectTypeId, property, getAdditionalPropertyValues) => {
  if (objectTypeId !== PRODUCT_TYPE_ID || !property.hubspotDefined) {
    // if objectTypeId is not a product or it's a custom property, it should be editable
    return false;
  }
  const bundleType = getAdditionalPropertyValues === null || getAdditionalPropertyValues === void 0 ? void 0 : getAdditionalPropertyValues('hs_bundle_type');
  if (bundleType && bundleType !== 'none') {
    if (EDITABLE_PRODUCT_BUNDLE_PROPERTIES.has(property.name)) {
      return false;
    }
    return true;
  }
  if (property.name === 'hs_pricing_model') {
    return true;
  }
  if (isMultiCurrencyPrice(property) || property.name === 'price') {
    const pricingModel = getAdditionalPropertyValues === null || getAdditionalPropertyValues === void 0 ? void 0 : getAdditionalPropertyValues('hs_pricing_model');
    if (isPricingModelTiered(pricingModel)) {
      return true;
    }
    return false;
  }
  return false;
};